
import { Box, Typography } from "@mui/material";

const AnonymousReporter = ({ reporter }) => {
  if (!reporter) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      mt={1.5}
    >
      {reporter.image && (
        <Box
          component="img"
          src={reporter.image}
          alt=""
          sx={{
            width: 24,
            height: 24,
            objectFit: "contain",
          }}
        />
      )}

      <Typography variant="body2" color="text.secondary">
        Reported by {reporter.name}
      </Typography>
    </Box>
  );
};

export default AnonymousReporter;